import React, { useState } from "react";
import CheckboxItem, {
  CHECKBOX_STATES,
} from "@javascript/reactComponents/lds/selection_controls/CheckboxItem";
import NewEventChip from "../shared/chips/NewEventChip";
import Table from "@javascript/reactComponents/lds/table/Table";
import Header from "@javascript/reactComponents/lds/table/Header";
import Body from "@javascript/reactComponents/lds/table/Body";
import Row from "@javascript/reactComponents/lds/table/Row";
import Cell from "@javascript/reactComponents/lds/table/Cell";
import Icon from "@javascript/reactComponents/lds/Icon";

function HomeFeedTableRow({ feed, onSelected }) {
  const feedUrl = `/feeds/${feed.id}/display_saved_feed`;

  const goToFeed = () => {
    window.location = feedUrl;
  };

  return (
    <Row>
      <Cell>
        <a href={feedUrl}>{feed.name}</a>
      </Cell>
      <Cell className="home-feed-row-chip" onClick={() => goToFeed(feed.id)}>
        <NewEventChip label={`${feed.new_event_count} events`} size="small" />
      </Cell>
      <Cell id={`feed-checkbox-${feed.id}`} justify="center">
        <CheckboxItem
          selection={
            feed.hidden ? CHECKBOX_STATES.unselected : CHECKBOX_STATES.selected
          }
          onClick={onSelected}
          value={feed.id}
        />
      </Cell>
    </Row>
  );
}

function HomeFeedTableBody({ title, initialFeeds = [] }) {
  const [feeds, setFeeds] = useState(initialFeeds);

  const onFeedCheckboxSelected = (value) => {
    change_home_page_setting(value);
    setFeeds(
      feeds.map((feed) => {
        return { ...feed, hidden: feed.id === value || feed.hidden };
      })
    );
  };

  const rows = feeds
    .filter((feed) => !feed.hidden)
    .map((feed) => {
      return (
        <HomeFeedTableRow
          feed={feed}
          onSelected={onFeedCheckboxSelected}
          key={feed.id}
        />
      );
    });

  return (
    <Table width="100%">
      <Header>
        <Row header>
          <Cell header width="100%">
            {title}
          </Cell>
          <Cell header minWidth="140px">
            New Activity
          </Cell>
          <Cell header minWidth="120px">
            Show on <Icon name="home" filled className="home-feed-table-body-home-icon" />
          </Cell>
        </Row>
      </Header>
      <Body>{rows}</Body>
    </Table>
  );
}

export default HomeFeedTableBody;

window.HomeFeedTableBody = HomeFeedTableBody;
